import { DatabaseFieldType } from '@databases/types/database';
import { type ReactNode } from 'react';
import { createContentColumnFieldReadModule } from '../content-column-field-read-module.ts';
import { type ContentColumnReadPolicy } from '../content-column-read.ts';
import {
  EMPTY_PAGE_STATUS_CONTENT,
  type PageStatusReadContent
} from './page-status-read-content.ts';

export type PageStatusReadPolicy = ContentColumnReadPolicy;
export type PageStatusReadRenderer = (content: PageStatusReadContent) => ReactNode;
/**
 * Status ignores editor overrides and reads the referenced page through the shared column owner.
 */
export function createPageStatusFieldReadModule(
  options?: PageStatusReadPolicy & { readonly render?: PageStatusReadRenderer }
) {
  return createContentColumnFieldReadModule(
    {
      fieldType: DatabaseFieldType.PAGE_STATUS,
      emptyContent: EMPTY_PAGE_STATUS_CONTENT,
      getColumn: () => 'pageStatus'
    },
    options
  );
}
